import { logWithSentry, SentryErrorKind } from './initSentry';

/* eslint-disable no-console */
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');

        console.log(`Service worker registration successful with scope: ${registration.scope}`);
      } catch (error) {
        logWithSentry(error, SentryErrorKind.other);
        console.log(`Service worker registration failed with ${error}`);
      }
    });
  }
};

if (import.meta.env.PROD) {
  registerServiceWorker();
}
